<app-common-header [isAdminOrTutor]="role === '1' || role === '2'">
</app-common-header>
<div class="page-content">
  <main class="main-panel">
    <form [formGroup]="batchForm">
      <div class="batch">
        <span class="batch__heading">Batch Creation</span>
        <div class="batch__batchData">
          <div class="batch__batchData__block">
            <div
              class="batch__batchData__block__firstRow batch__batchData__block__firstRow--bigElement"
            >
              <span>Batch Name</span>
              <input
                formControlName="batchName"
                class="batch__name"
                placeholder="Enter batch name"
              />
            </div>
            <div
              class="batch__batchData__block__firstRow batch__batchData__block__firstRow--bigElement"
            >
              <span>Course</span>
              <mat-select
                [(ngModel)]="selectedCourseId"
                [ngModelOptions]="{ standalone: true }"
                name="course"
                (selectionChange)="onCourseSelect($event.value)"
              >
                <mat-option
                  *ngFor="let course of courses"
                  [value]="course.courseId"
                  >{{ course.courseName }}</mat-option
                >
              </mat-select>
            </div>
            <div class="batch__batchData__block__firstRow">
              <span>Start Date</span>
              <div class="batch__batchData__block__date">
                <input
                  matInput
                  class="batch__batchData__block__date__input"
                  [matDatepicker]="startDatePicker"
                  [max]="batchForm.get('end_date')?.value"
                  formControlName="start_date"
                  readonly
                  (click)="startDatePicker.open()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="startDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
              </div>
            </div>
            <div class="batch__batchData__block__firstRow">
              <span>End Date</span>
              <div class="batch__batchData__block__date">
                <input
                  matInput
                  class="batch__batchData__block__date__input"
                  [matDatepicker]="endDatePicker"
                  [min]="batchForm.get('start_date')?.value"
                  formControlName="end_date"
                  readonly
                  (click)="endDatePicker.open()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="endDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
              </div>
            </div>
            <aside class="sidebar">
              <button
                mat-raised-button
                color="primary"
                class="create-btn"
                type="button"
                [attr.aria-expanded]="showSchedule"
                (click)="showSchedule = !showSchedule"
              >
                Schedule Class
              </button>
            </aside>
          </div>
          <div class="batch__batchData__selectedCourse">
            <span class="batch__batchData__selectedCourse__heading">
              Selected Courses
            </span>
            <ng-container
              *ngFor="let course of selectedCourses; index as courseIndex"
            >
              <span class="batch__batchData__selectedCourse__name">
                <mat-icon
                  class="batch__batchData__selectedCourse__name__close"
                  (click)="removeCourse(courseIndex)"
                  >cancel</mat-icon
                >
                {{ course.value.courseName }}</span
              >
            </ng-container>
          </div>
        </div>
      </div>
      <mat-card class="calendar-card" *ngIf="showSchedule">
        <full-calendar
          #fullCalendar
          [options]="calendarOptions"
          [events]="calendarEvents"
        ></full-calendar>
      </mat-card>

      <mat-card
        class="students-card"
        *ngIf="screenType === 'update'"
        aria-labelledby="students-card-title"
      >
        <header class="students-card__header">
          <div class="students-card__badge" aria-hidden="true">
            <mat-icon>groups</mat-icon>
          </div>
          <div class="students-card__heading">
            <h3 id="students-card-title" class="students-card__title">
              Students
              <span class="students-card__count">{{
                selectedStudents.length
              }}</span>
            </h3>
            <p class="students-card__subtitle">
              Everyone enrolled in this batch's classes
            </p>
          </div>
          <div
            class="students-card__filter"
            *ngIf="selectedStudents.length > 6"
          >
            <mat-icon>search</mat-icon>
            <input
              type="search"
              placeholder="Filter students"
              aria-label="Filter students"
              [(ngModel)]="studentFilter"
              [ngModelOptions]="{ standalone: true }"
            />
          </div>
        </header>

        <div class="students-card__add">
          <p-multiSelect
            class="students-card__picker"
            styleClass="w-full"
            appendTo="body"
            [virtualScroll]="availableStudents.length > 50"
            [virtualScrollItemSize]="40"
            [scrollHeight]="'280px'"
            [options]="availableStudents"
            [optionValue]="'student_id'"
            [optionLabel]="'studentName'"
            [filter]="true"
            filterPlaceHolder="Search by name"
            [maxSelectedLabels]="2"
            [selectedItemsLabel]="'{0} students selected'"
            [defaultLabel]="
              availableStudents.length
                ? 'Search students to add'
                : 'Every student is already in this batch'
            "
            [disabled]="!availableStudents.length"
            [(ngModel)]="selectedStudentIds"
            [ngModelOptions]="{ standalone: true }"
          ></p-multiSelect>
          <button
            mat-flat-button
            color="primary"
            type="button"
            class="students-card__add-button"
            [disabled]="!selectedStudentIds.length"
            (click)="addStudents()"
          >
            <mat-icon>person_add</mat-icon>
            Add{{
              selectedStudentIds.length > 1
                ? " " + selectedStudentIds.length
                : ""
            }}
          </button>
        </div>

        <ul
          class="students-card__grid"
          *ngIf="filteredStudents.length; else noStudents"
          aria-label="Students in this batch"
        >
          <li
            class="student-tile"
            [class.student-tile--new]="student.value.bstId == null"
            *ngFor="let student of filteredStudents; trackBy: trackByStudent"
          >
            <span
              class="student-tile__avatar"
              [ngClass]="studentAvatarClass(student.value.studentId)"
              aria-hidden="true"
              >{{ studentInitials(student.value.studentName) }}</span
            >
            <span class="student-tile__name capitalize">{{
              student.value.studentName
            }}</span>
            <button
              mat-icon-button
              type="button"
              class="student-tile__remove"
              [attr.aria-label]="'Remove ' + student.value.studentName"
              matTooltip="Remove from batch"
              (click)="removeStudentControl(student)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </li>
        </ul>
        <ng-template #noStudents>
          <div class="students-card__empty" *ngIf="!selectedStudents.length">
            <div class="students-card__empty-icon" aria-hidden="true">
              <mat-icon>group_add</mat-icon>
            </div>
            <p class="students-card__empty-title">No students yet</p>
            <p class="students-card__empty-text">
              Search above to add students to this batch.
            </p>
          </div>
          <div class="students-card__no-match" *ngIf="selectedStudents.length">
            No students match "{{ studentFilter }}"
          </div>
        </ng-template>
      </mat-card>

      <div class="batch-actions">
        <div class="batch-actions__status" aria-live="polite">
          <ng-container *ngIf="unsavedChanges.length">
            <mat-icon>pending</mat-icon>
            <span>Unsaved: {{ unsavedChanges.join(", ") }}</span>
          </ng-container>
        </div>
        <mat-slide-toggle formControlName="isBatchActive" color="primary"
          >Active</mat-slide-toggle
        >
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="batch-actions__save"
          (click)="createOrUpdateBatch()"
          [disabled]="createOrUpdateBatchClicked"
        >
          <mat-icon>check</mat-icon>
          {{ screenType === 'create' ? 'Create Batch' : 'Update Batch' }}
        </button>
      </div>
    </form>
  </main>
</div>
